import './rest_api.js';

(function ($) {
    "use strict";
    var mobileIndicator = false;
    // On teste si on est sur mobile ou pas (cf styles.css + footer.php)
    if ($('#mobile-indicator').is(':visible')) {
        mobileIndicator = true;
    } else {
        mobileIndicator = false;
    }
    // On teste aussi lors de tout resize et on rechargge la page en cas de changement de media query
    $(window).resize(
        function () {
            if ($('#mobile-indicator').is(':visible')) {
                if (mobileIndicator === false) {
                    mobileIndicator = true;
                    location.reload(); // On recharge la page si la media query a changé
                }
            } else {
                if (mobileIndicator == true) {
                    mobileIndicator = false;
                    location.reload(); // On recharge la page si la media query a changé
                }
            }
        }
    );

    if (mobileIndicator === false) {
        // DESKTOP

    } else {
        // MOBILE

        //Hamburger menu
        if ($('.burger').length > 0) {
            $('.burger').on(
                'click',
                function (event) {
                    event.preventDefault();
                    $('.wp-block-menu-mobile').toggleClass('active');
                    $('.veganburger').toggleClass('active');
                    $('.block-menu-mobile__content').slideToggle();
                }
            );
        }

    }

    // MOBILE ET DESKTOP

    //Slider
    if ($('.splide').length > 0) {
        var splide = new Splide(
            '.splide',
            {
                perPage: 3,
                rewind: true,
                breakpoints: {
                    1024: {
                        perPage: 2
                    },
                    855: {
                        perPage: 1
                    },
                    600: {
                        arrows: false
                    }
                }
            }
        );
        splide.mount();
    }

    //Moteur de recherche select
    if ($('.dropdown').length > 0) {
        $('.dropdown-toggle').on(
            'click',
            function (event) {
                event.preventDefault();
                $(this).parents('.style-dropdown').siblings('.style-dropdown.active').find('.dropdown-items').css('display', 'none');
                $(this).parents('.style-dropdown').siblings('.style-dropdown.active').removeClass('active');
                $(this).parents('.style-dropdown').toggleClass('active');
                $(this).parent('.dropdown').find('.dropdown-items').slideToggle();
            }
        );

        $('.dropdown .wp-block-alert').on(
            'click',
            function (event) {
                event.preventDefault();
                $(this).toggleClass('unselectAll');
                $(this).html() == 'Tout sélectionner' ? $(this).html('Tout déselectionner') : $(this).html('Tout sélectionner');
                if ($(this).hasClass('unselectAll')) {
                    var inputChecked = $(this).parents('.dropdown-items').find('.dropdown-item').length;
                    $(this).parents('.dropdown').find('.countdown-number').html(inputChecked);
                    $(this).parents('.dropdown').find('.dropdown-toggle').addClass('itemSelected');
                    $(this).parents('.dropdown-items').find(':input').each(function () {
                        $(this).prop('checked', true);
                    });
                } else {
                    $(this).parents('.dropdown').find('.countdown-number').html(0);
                    $(this).parents('.dropdown').find('.dropdown-toggle').removeClass('itemSelected');
                    $(this).parents('.dropdown-items').find(':input').each(function () {
                        $(this).prop('checked', false);
                    });
                }
            }
        );

        $('.dropdown').each(function () {
            var checkboxes = $(this).find(':input[type="checkbox"]');
            checkboxes.change(function () {
                var countCheckedCheckboxes = checkboxes.filter(':checked').length;
                $(this).parents('.dropdown').find('.countdown-number').html(countCheckedCheckboxes);
                if (countCheckedCheckboxes > 0) {
                    if (!$(this).parents('.dropdown').find('.dropdown-toggle').hasClass('itemSelected')) {
                        $(this).parents('.dropdown').find('.dropdown-toggle').addClass('itemSelected');
                    }
                }
                if (countCheckedCheckboxes === 0) {
                    $(this).parents('.dropdown').find('.dropdown-toggle').removeClass('itemSelected');
                }
            });
        });
    }

    //ACF select mise en forme
    if ($('.page-template-template-expert_works').length > 0) {
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            '.acf-select .acf-checkbox-list>li>label',
            function (event) {
                event.preventDefault();
                $(this).removeClass('selected');
                $(this).parents('li').siblings('li.active').find('.children').css('display', 'none');
                $(this).parents('li').siblings('li.active').removeClass('active');
                $(this).parents('li').toggleClass('active');
                $(this).parent('li').find('.children').slideToggle();
            }
        );
    } else if ($('.acf-select').length > 0) {
        $('.acf-select .acf-checkbox-list>li>label').on(
            'click',
            function (event) {
                event.preventDefault();
                $(this).removeClass('selected');
                $(this).parents('li').siblings('li.active').find('.children').css('display', 'none');
                $(this).parents('li').siblings('li.active').removeClass('active');
                $(this).parents('li').toggleClass('active');
                $(this).parent('li').find('.children').slideToggle();
            }
        );
    }

    //ACF checkbox mise en forme
    if ($('.page-template-template-expert_works').length > 0) {
        $('.page-template-template-expert_works .container__1325').on(
            'click',
            'input[type="checkbox"]',
            function (event) {
                $(this).parent('label').toggleClass('selected');
            }
        );
    } else if ($('.acf-checkbox').length > 0) {
        $('input[type="checkbox"]').on(
            'click',
            function (event) {
                $(this).parent('label').toggleClass('selected');
            }
        );
    }

    //Notifications
    if ($('.is-style-notifications').length > 0) {
        $('.is-style-notifications .wp-block-button__link').on(
            'click',
            function (event) {
                event.preventDefault();
                if ($('.notifications-number').hasClass('active')) {
                    $('.notifications-number').removeClass('active');
                }
                $(this).parent('.wp-block-button').find('.notifications-menu').slideToggle();
            }
        );
    }


    //Multiselect
    if ($('#select-thematiques.tomselected').length > 0) {
        new TomSelect(
            "#select-thematiques",
            {
                plugins: ['remove_button'],
                create: true,
                onItemAdd: function () {
                    this.setTextboxValue('');
                    this.refreshOptions();
                }
            }
        );
    }

    //Multiselect
    if ($('#orderby-select-territory.tomselected').length > 0) {
        new TomSelect(
            "#orderby-select-territory",
            {
                plugins: ['remove_button'],
                create: true,
                onItemAdd: function () {
                    this.setTextboxValue('');
                    this.refreshOptions();
                }
            }
        );
    }

    //Multiselect
    if ($('#orderby-select-theme.tomselected').length > 0) {
        new TomSelect(
            "#orderby-select-theme",
            {
                plugins: ['remove_button'],
                create: true,
                onItemAdd: function () {
                    this.setTextboxValue('');
                    this.refreshOptions();
                }
            }
        );
    }

    if ($('.login-remember').length > 0) {
        $('.login-remember input').on(
            'click',
            function (event) {
                event.preventDefault();
                $(this).parent('label').toggleClass('checked');
            }
        );
    }

    //Formulaire de connexion visibilité du mot de passe
    if ($('.login-password').length > 0) {
        $('.login-password').append($('<span class="dashicons dashicons-visibility"></span>'));
        $('.dashicons').on(
            'click',
            function (event) {
                event.preventDefault();
                if ($(this).hasClass('dashicons-visibility')) {
                    $(this).removeClass('dashicons-visibility');
                    $(this).addClass('dashicons-hidden');
                    $(this).parent('.login-password').find('input').attr('type', 'text');
                } else if ($(this).hasClass('dashicons-hidden')) {
                    $(this).removeClass('dashicons-hidden');
                    $(this).addClass('dashicons-visibility');
                    $(this).parent('.login-password').find('input').attr('type', 'password');
                }
            }
        );
    }

    //Personnalisation du site, aperçu des thèmes
    if ($('.block-modal-theme').length > 0) {
        $('.overview-panel').on(
            'click',
            function (event) {
                event.preventDefault();
                var theme = $(this).attr('data-theme');
                var themeColor = document.getElementById('dialog' + theme);
                themeColor.showModal();
            }
        );
    }

    //Signalement d’une ressource
    if ($('.is-style-ressource-alert .wp-block-button__link').length > 0) {
        $('.is-style-ressource-alert .wp-block-button__link').on(
            'click',
            function (event) {
                event.preventDefault();
                $(this).toggleClass('active');
                $('.ressource__form-alert').slideToggle();
            }
        );
    }

    // vidéo native WordPress
    $(
        function () {
            $('.mejs-overlay-loading').closest('.mejs-overlay').addClass('load'); // just a helper class

            var $video = $('div.video video');
            var vidWidth = $video.attr('width');
            var vidHeight = $video.attr('height');

            $(window).resize(
                function () {
                    var targetWidth = $(this).width(); // using window width here will proportion the video to be fullscreen; adjust as needed
                    $('div.video, div.video .mejs-container').css('height', Math.ceil(vidHeight * (targetWidth / vidWidth)));
                }
            ).resize();
        }
    );


    if (typeof acf != 'undefined') {
        acf.addAction(
            'load_field/name=ombree__partner__filter_thematiques',
            function ($field) {

                if ($('#thematiques-add').length > 0 && $('#thematiques-remove').length > 0) {
                    var thematiques_add = $('#thematiques-add');
                    var thematiques_remove = $('#thematiques-remove');
                    thematiques_add.unbind();
                    thematiques_remove.unbind();

                    thematiques_add.find('.acf-input input').unbind();
                    thematiques_remove.find('.acf-input input').unbind();

                    thematiques_add.on(
                        'click',
                        '.acf-input label',
                        function () {
                            $(this).addClass('selected');
                            var element = $(this).find('input')
                                .prop('checked', true)
                                .val();
                            thematiques_remove.find('input[value="' + element + '"]')
                                .prop('checked', true)
                                .parent('label').addClass('selected');

                        }
                    );
                    thematiques_remove.on(
                        'click',
                        '.acf-input label',
                        function () {
                            $(this).removeClass('selected');
                            var element = $(this).find('input')
                                .prop('checked', false)
                                .val();
                            thematiques_add.find('input[value="' + element + '"]')
                                .prop('checked', false)
                                .parent('label').removeClass('selected');

                        }
                    );
                }
            }
        );
    }

    if ($('#thematiques-add input[value^="parent_"]').length > 0) {
        $('#thematiques-add input[value^="parent_"]').attr('disabled', 'disabled');
        $('#thematiques-add input[value^="parent_"]').parent('label').addClass('thematique_parent');
        $('#thematiques-remove input[value^="parent_"]').attr('disabled', 'disabled');
        $('#thematiques-remove input[value^="parent_"]').parent('label').addClass('thematique_parent');
    }


    if ($('#acf-form').length > 0) {
        $('#acf-form').on('change', '#acf-field_62860b690320a', function () {
            var text;
            if ($('#acf-field_62860b690320a:checked').val() == 1) {
                text = 'Soumettre';
            } else {
                text = 'Mise à jour';
            }

            $('.acf-form-submit input').attr('value', text);
        });
        $('#acf-form').on('change', '#acf-field_62c67a5ed573d', function () {
            var text;
            if ($('#acf-field_62c67a5ed573d:checked').val() == 1) {
                text = 'Publier';
            } else {
                text = 'Mise à jour';
            }

            $('.acf-form-submit input').attr('value', text);
        });
    }

    // #9496 : demande de dupliquer le bouton "mise à jour" dans la section CONFIGURATION DE MES CHOIX
    $('body.page-template-template-settings_site .acf-form-submit').clone().insertBefore('.acf-field-6271362dd1edbe');

    // #9797 recup du nombre de ressources pour l'afficher à l'ouverture du formulaire avancé
    if ($('body').length > 0) {
        if ($('#results-query-items [data-all_ressources]').length > 0) {
            // get data from data attribute
            var all_ressources = $('#results-query-items [data-all_ressources]').attr('data-all_ressources');
            // set value in #count_ressources and concat "Résultat", if all_ressources > 0 add s to "Résultat"
            $('#count_ressources').text(all_ressources + ' résultat' + (all_ressources > 1 ? 's' : ''));
        }
    }

    if ($('body').length > 0) {
        if ($('.wp-block-expert-directory[data-count-directory]').length > 0) {
            // get data from data attribute
            var all_directory = $('.wp-block-expert-directory[data-count-directory]').attr('data-count-directory');
            // set value in #count_ressources and concat "Résultat", if all_ressources > 0 add s to "Résultat"
            $('#count_ressources').text(all_directory + ' résultat' + (all_directory > 1 ? 's' : ''));
            $('#count_ressources').css('color', '#405974');
        }
    }

    if ($('body').length > 0) {
        if ($('.wp-block-partner-directory[data-count-directory]').length > 0) {
            // get data from data attribute
            var all_directory = $('.wp-block-partner-directory[data-count-directory]').attr('data-count-directory');
            // set value in #count_ressources and concat "Résultat", if all_ressources > 0 add s to "Résultat"
            $('#count_ressources').text(all_directory + ' résultat' + (all_directory > 1 ? 's' : ''));
            $('#count_ressources').css('color', '#405974');
        }
    }

    function get_redirect_url_back(back_button, route) {
        $.ajax(
            {
                url: OMBREE_INFO.api_url_back + '/' + route,
                type: "GET",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', OMBREE_INFO.rest);
                },
            }
        ).done(
            function (response) {
                back_button.attr('href', response.url);
                back_button.find('span').text(response.text);

            }
        ).always(
            function () {
                // $('.wp-block-loader').remove();
                // $this.prop('disabled', false);
            }
        );
    }

    // get ajax_get_redirect_list_data WordPress
    if ($('#header .header__classic-content .wp-block-button.is-style-back .wp-block-button__link').length > 0) {
        var back_button = $('#header .header__classic-content .wp-block-button.is-style-back .wp-block-button__link');
        get_redirect_url_back(back_button, 'ressources_url');
    }

    if ($('body.single-ressource').length > 0) {
        if ($('#main .wp-block-button.is-style-back .wp-block-button__link').length > 0) {
            var back_button = $('#main .wp-block-button.is-style-back .wp-block-button__link');
            get_redirect_url_back(back_button, 'ressources_url_singular');
        }
    }

    // only body.home
    if ($('body.home').length > 0) {
        // set document.cookie ombree__cookie_home to current url for 30 days
        document.cookie = 'ombree__cookie_home=' + window.location.href + ';max-age=2592000;path=/';
    }

})(jQuery);
